import { render, staticRenderFns } from "./EqifyQueryBuilderFederationTemplateModal.vue?vue&type=template&id=12a23b24&scoped=true"
import script from "./EqifyQueryBuilderFederationTemplateModal.vue?vue&type=script&lang=ts"
export * from "./EqifyQueryBuilderFederationTemplateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a23b24",
  null
  
)

export default component.exports